import ImageZoom from "../../commons/ImageZoom";

const Diffuseur = () => {
  return (
    <div className="portfolio">
      <header className="portfolio-header">
        <p className="portfolio-kicker">Hardware &amp; IoT</p>
        <h1>Diffuseur de parfum</h1>
        <p>
          Kiosques interactifs avec diffusion de parfum, LED réactives et
          Raspberry Pi — une expérience multisensorielle en magasin.
        </p>
      </header>

      <section className="portfolio-section">
        <h2>Fonctionnalités</h2>
        <div className="portfolio-projects">
          <div className="project">
            <ImageZoom
              style={{ height: "200px", width: "auto", objectFit: "cover" }}
              alt="LED interactives du kiosque"
              src="./assets/diffuseur1.jpg"
            />
            <h3>Interaction LED</h3>
            <p>
              Lumières qui réagissent aux actions des utilisateurs, pour créer
              une ambiance avant même la diffusion du parfum.
            </p>
          </div>
          <div className="project">
            <ImageZoom
              style={{ height: "200px", width: "auto", objectFit: "cover" }}
              alt="Diffusion de parfum personnalisée"
              src="./assets/diffuseur2.jpeg"
            />
            <h3>Parfum sur mesure</h3>
            <p>
              Choix du parfum sur écran tactile, puis lancement automatique du
              diffuseur pour une expérience sensorielle complète.
            </p>
          </div>
        </div>
      </section>

      <section className="portfolio-section">
        <h2>À propos du projet</h2>
        <p>
          Conception de bornes interactives intégrant un diffuseur de parfum.
          Chaque borne repose sur un Raspberry Pi 4 pilotant LED, capteurs et
          moteur de diffusion via GPIO.
        </p>
        <p>
          À l’approche d’un utilisateur, les LED s’allument et un menu
          tactile propose plusieurs parfums. Capteurs de proximité et de
          pression enrichissent l’interaction ; l’interface Android reste
          fluide pendant que le Pi gère le matériel.
        </p>
      </section>

      <footer className="portfolio-footer">
        <a href="mailto:julien.j.1999@hotmail.com">
          Contactez-moi : julien.j.1999@hotmail.com
        </a>
      </footer>
    </div>
  );
};

export default Diffuseur;
